export const NAVIGATION = {
  FOR_YOU_DETAIL: "/per-te/dettaglio/:id/:learningObjectTypology"
};
